import { ArticleEstimation, ItemEstimation, MonthEstimation } from '../../../domain/estimations/Estimations';
import { MonthEstimationDraftDto } from './estimationsPlace';
import Estimations from '../../../domain/estimations/Estimations';

export default (estimations: Estimations): MonthEstimationDraftDto[] =>
    estimations.map(
        (e: MonthEstimation): MonthEstimationDraftDto => {
            return {
                month: e.month,
                articlesEstimations: e.articlesEstimations.map((a: ArticleEstimation) => {
                    return {
                        articleId: a.articleId,
                        itemsEstimations: a.itemsEstimations.map((i: ItemEstimation) => {
                            return {
                                sku: i.sku,
                                value: i.value
                            };
                        })
                    };
                })
            };
        }
    );



// WEBPACK FOOTER //
// ./src/application/estimations/epic/estimationsToDto.ts